
import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { StrategyProvider } from "@/types/strategy-types";

interface LeadAccountTableFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onAddNew: () => void;
  providers?: StrategyProvider[];
  selectedProvider?: string;
  onProviderChange?: (value: string) => void;
}

const LeadAccountTableFilters = ({
  searchTerm,
  onSearchChange,
  onAddNew,
  providers,
  selectedProvider,
  onProviderChange
}: LeadAccountTableFiltersProps) => {
  return (
    <div className="flex flex-col md:flex-row gap-4 mb-6">
      <div className="w-full md:w-1/3">
        <Input
          placeholder="Search by ID, exchange, or provider name..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full"
        />
      </div>
      
      {providers && onProviderChange && (
        <div className="w-full md:w-1/3">
          <Select
            value={selectedProvider || "all"}
            onValueChange={onProviderChange}
          >
            <SelectTrigger>
              <SelectValue placeholder="Filter by provider" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Providers</SelectItem>
              {providers.map((provider) => (
                <SelectItem key={provider.id} value={provider.id}>
                  {provider.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}
      
      <Button onClick={onAddNew} className="md:ml-auto">
        Add Lead Account
      </Button>
    </div>
  );
};

export default LeadAccountTableFilters;
